import {
    Component,
    EventEmitter,
    Input,
    Output,
    OnInit,
    ViewChild,
    ElementRef
} from '@angular/core';
import { LazyLoadEvent, TreeNode, MessageService } from 'primeng/api';
import { TreeTable } from 'primeng/treetable';
import { IdName } from '../domain/idname';
import { TreeAccountsComponent } from './tree-accounts.component';
import { Totaling } from '../domain/totaling';
import { AccountService } from '../service/account.service';
import { ChipsModule } from 'primeng/chips';

@Component({
    selector: 'app-accounts-totaling-picker',
    templateUrl: './accounts-totaling-picker.component.html',
    styles: [
        `
            :host ::ng-deep .priority-2,
            :host ::ng-deep .priority-3,
            :host ::ng-deep .visibility-sm {
                display: none;
            }

            ::ng-deep .your-table .ui-treetable-scrollable-view .ui-treetable-scrollable-body {
                min-height: 300px !important;
            }

            @media screen and (max-width: 39.938em) {
                :host ::ng-deep .visibility-sm {
                    display: inline;
                }
            }

            @media screen and (min-width: 40em) {
                :host ::ng-deep .priority-2 {
                    display: table-cell;
                }
            }

            @media screen and (min-width: 64em) {
                :host ::ng-deep .priority-3 {
                    display: table-cell;
                }
            }
        `
    ]
})
export class AccountsTotalingPickerComponent implements OnInit {
    constructor(private accountService: AccountService) {}

    @Input() reportId: string;
    @Input() lineId: string;
    @Input() totaling: Totaling[]; //Accounts from other chipses
    @Output() totalingChange = new EventEmitter();

    @Input() messageService: MessageService;

    @Output() voted = new EventEmitter<boolean>();

    @ViewChild('accountsIncludedTree', { static: false })
    accountsIncludedTree: TreeAccountsComponent;
    @ViewChild('accountsLineTree', { static: false })
    accountsLineTree: TreeAccountsComponent;
    @ViewChild('accountsExcludedTree', { static: false })
    accountsExcludedTree: TreeAccountsComponent;
    @ViewChild('accountsAllTree', { static: false })
    accountsAllTree: TreeAccountsComponent;
    @ViewChild('accountsTotalingTree', { static: false })
    accountsTotalingTree: TreeTable;
    @ViewChild('accountsExcludedTreeRangeLeft', { static: false })
    accountsExcludedTreeRangeLeft: TreeAccountsComponent;
    @ViewChild('accountsExcludedTreeRangeRight', { static: false })
    accountsExcludedTreeRangeRight: TreeAccountsComponent;

    @Input() filter: IdName[];

    @ViewChild('searchTree', { static: false }) searchTree: ElementRef;

    items: any[];

    displayAccountTotaling = false;

    index = 0;

    tableColumns: any[];

    selectedAccountTotalingList: Array<TreeNode>; //Selected accounts from tree on the right side (first tab)
    selectedAccountTotalingRange1: TreeNode;
    selectedAccountTotalingRange2: TreeNode;

    accountsTotaling: TreeNode[] = []; //Selected accounts from tree on the left side (first tab)
    selected: TreeNode;
    currentTotaling: Totaling = null;

    ngOnInit() {
        this.tableColumns = [{ field: 'code', header: 'Code', width:'20%' }, { field: 'name', header: 'Name', width:'80%' }];

        this.items = [
            {
                label: 'Delete',
                icon: 'ui-delete',
                command: event => this.delete(this.selected)
            }
        ];
    }

    delete(item: TreeNode) {
        this.accountsTotaling.splice(
            this.accountsTotaling.findIndex(
                node => node.data.id === item.data.id
            ),
            1
        );
        this.accountsTotalingTree.value = this.accountsTotaling;
        this.accountsExcludedTree.selectedLines = this.accountsTotaling;
        this.accountsExcludedTree.refresh();
    }

    unpick() {
        if (this.selected) {
            this.delete(this.selected);
        }
    }

    changeTotaling(newValue) {
        this.totaling = newValue;
        this.totalingChange.emit(newValue);
        this.accountService.setAllAccountsTotalingsIds(this.totaling);
    }

    okClickAccountTotaling() {

        //this.displayAccountTotaling = false;

        if (this.totaling === undefined) {
            this.totaling = Array<Totaling>();
        }

        if (this.index === 0) {
            let ids: string;
            let names: string;
            let descriptions: string;

            ids = '';
            names = '';
            descriptions = '';

            this.accountsTotaling.forEach(element => {
                ids = ids + element.data.id + '|';
                names = names + element.data.code + '|';
                descriptions =
                    '<p>' +
                    descriptions +
                    element.data.code +
                    ' - ' +
                    element.data.name +
                    '</p>';
            });

            ids = ids.substring(0, ids.length - 1);
            names = names.substring(0, names.length - 1);
            if (this.currentTotaling === null) {
                const chip = new Totaling();
                chip.Type = 3;
                chip.Ids = ids;
                chip.Names = names;
                chip.Descriptions = descriptions;
                this.totaling.push(chip);
            } else {
                const chip = this.currentTotaling;
                chip.Type = 3;
                chip.Ids = ids;
                chip.Names = names;
                chip.Descriptions = descriptions;
            }
        } else if (this.index === 1) {

            let ids: string;
            let names: string;
            let descriptions: string;

            ids = '';
            names = '';
            descriptions = '';

            ids =
                this.selectedAccountTotalingRange1.data.id +
                '..' +
                this.selectedAccountTotalingRange2.data.id;
            names =
                this.selectedAccountTotalingRange1.data.code +
                '..' +
                this.selectedAccountTotalingRange2.data.code;
            descriptions =
                this.selectedAccountTotalingRange1.data.code + " - " + this.selectedAccountTotalingRange1.data.name +
                '..' +
                this.selectedAccountTotalingRange2.data.code + " - " + this.selectedAccountTotalingRange2.data.name;

            if (this.currentTotaling === null) {
                const chip2 = new Totaling();
                chip2.Type = 2;
                chip2.Ids = ids;
                chip2.Names = names;
                chip2.Descriptions = descriptions;
                this.totaling.push(chip2);
            } else {
                const chip2 = this.currentTotaling;
                chip2.Type = 2;
                chip2.Ids = ids;
                chip2.Names = names;
                chip2.Descriptions = descriptions;
                this.totaling.push(chip2);
            }
        }

        this.selectedAccountTotalingList = new Array<TreeNode>();
        this.selectedAccountTotalingRange1 = null;
        this.selectedAccountTotalingRange2 = null;

        this.currentTotaling = null;

        this.changeTotaling(this.totaling);

        this.accountsTotaling = [];
    }

    handleChange(e) {
        this.index = e.index;
    }

    onRemove() {
        this.changeTotaling(this.totaling);
    }

    onChipClick(event: any) {
        if (event.value.Type == 3) //is a single(s)
        {
            this.currentTotaling = event.value;
            this.accountService
                .createTreeFor(event.value.Ids.trim())
                .then(obj => (this.accountsTotaling = obj))
                .then(obj => (this.displayAccountTotaling = true))
                .then(obj => {
                    this.accountsTotaling.forEach(node => {
                        this.expandRecursive(node, false);
                    });
                    this.accountsTotaling = [...this.accountsTotaling];
                });
            this.accountService.setAllAccountsTotalingsIds(this.totaling);
        }

        if (event.value.Type == 2) //is a range
        {

            //TODO: Backend is calling for all excluded accounts, so beginning and ending accounts of range are not included and thus cannot be selected when editing saved ranges
            /*
            var rangeIds = [];
            event.value.Ids.split("..").forEach(id => {
                rangeIds.push(Number(id))
            });

            //get accounts from server by id
            this.accountService
                .createTreeFor(rangeIds[0])
                .then(accounts => {
                    this.selectedAccountTotalingRange1 = accounts[0];
                })
                .then(() => {
                    this.accountService
                        .createTreeFor(rangeIds[1])
                        .then(accounts => {
                            this.selectedAccountTotalingRange2 = accounts[0];
                        })
                        .then(() => {
                            this.index = 1;
                            this.displayAccountTotaling = true;
                        });
                });
                */
        }
    }

    private expandRecursive(node: TreeNode, isExpand: boolean) {
        node.expanded = isExpand;
        if (!node.leaf && node.children != null) {
            node.children.forEach(childNode => {
                this.expandRecursive(childNode, isExpand);
            });
        }
    }

    pickAllFilteredAccounts(filteredAccounts)
    {
        this.selectedAccountTotalingList = filteredAccounts;
        this.selectedAccountTotalingList.forEach(node => {
            this.accountsTotaling.push(node);
            this.accountsTotaling.forEach(n => {
                this.expandRecursive(n, false);
            });
            this.accountsTotaling = [...this.accountsTotaling];

            this.accountsExcludedTree.accounts.forEach(parentNode => {
                if (parentNode.data.id === node.data.id) {
                    this.accountsExcludedTree.accounts.splice(
                        this.accountsExcludedTree.accounts.findIndex(
                            value => value.data.id === parentNode.data.id
                        ),
                        1
                    );
                } else {
                    this.accountsExcludedTree.deleteNodeById(
                        parentNode,
                        node.data.id
                    );
                }
            });
        });

        this.selectedAccountTotalingList.splice(
            0,
            this.selectedAccountTotalingList.length
        );
        this.selectedAccountTotalingList = [];

        this.accountsExcludedTree.tree.value = this.accountsExcludedTree.accounts;
        this.accountsTotalingTree.value = this.accountsTotaling;
        this.accountService.setAllAccountsTotalingsIds(this.totaling);
    }

    pick() {
        this.selectedAccountTotalingList.forEach(node => {
            this.accountsTotaling.push(node);
            this.accountsTotaling.forEach(n => {
                this.expandRecursive(n, false);
            });
            this.accountsTotaling = [...this.accountsTotaling];

            this.accountsExcludedTree.accounts.forEach(parentNode => {
                if (parentNode.data.id === node.data.id) {
                    this.accountsExcludedTree.accounts.splice(
                        this.accountsExcludedTree.accounts.findIndex(
                            value => value.data.id === parentNode.data.id
                        ),
                        1
                    );
                } else {
                    this.accountsExcludedTree.deleteNodeById(
                        parentNode,
                        node.data.id
                    );
                }
            });
        });

        this.selectedAccountTotalingList.splice(
            0,
            this.selectedAccountTotalingList.length
        );
        this.selectedAccountTotalingList = [];

        this.accountsExcludedTree.tree.value = this.accountsExcludedTree.accounts;
        this.accountsTotalingTree.value = this.accountsTotaling;
        this.accountService.setAllAccountsTotalingsIds(this.totaling);
    }

    pickNewAccountTotaling() {
        this.clearSelectedAccounts();
        this.displayAccountTotaling = true;
        this.accountService.setAllAccountsTotalingsIds(this.totaling);
    }

    removeUnselectedNode(unselectedNode: TreeNode) {
        this.selectedAccountTotalingList = this.selectedAccountTotalingList.filter(node => node.data.id !== unselectedNode.data.id);
    }

    clearSelectedAccounts() {
        if (
            this.accountsTotaling &&
            this.accountsTotaling.length >= 1
        ) {
            this.accountsTotaling.splice(0, this.accountsTotaling.length);
        }
        if (
            this.selectedAccountTotalingList !== undefined &&
            this.selectedAccountTotalingList.length >= 1
        ) {
            this.selectedAccountTotalingList.splice(
                0,
                this.selectedAccountTotalingList.length
            );
        }
    }
}
